(function () {
  var SEL = '#swym-registry-add-modal-btn, .swym-registry-add-modal-btn, #swym-registry-create-registry-btn';

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    window.location = '/account/login?return_url=' +
      encodeURIComponent(location.pathname + location.search);
  }, true);
})();
